module.exports = __webpack_public_path__ + "img/7.f5278942.jpg";